import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';

const styles = {
    avatar: {
        fontSize: '1rem',
        position: 'static',
        height: 30,
        width: 30
    }
};

const ReclamationGroupeAvatar = ({ classes, groupe, initiales }) => {
    return (
        <Tooltip title={groupe}>
            <Avatar className={classes.avatar}>{initiales}</Avatar>
        </Tooltip>
    );
}

ReclamationGroupeAvatar.propTypes = {
    classes: PropTypes.object.isRequired,
    groupe: PropTypes.string.isRequired,
    initiales: PropTypes.string.isRequired
};

export default withStyles(styles)(ReclamationGroupeAvatar);
